module.exports = __webpack_public_path__ + "static/media/ma-5.79761e64.svg";